import EmailAuthentication from 'apps/auth/components/ga/2fa/EmailAuthentication';
import GlobalAccounts from 'apps/auth/components/ga/accounts/GlobalAccounts';
import EmailNotificationGA from 'apps/auth/components/ga/email/EmailNotificationGA';
import GlobalAccountDownloadPage from 'apps/auth/components/ga/GlobalAccountDownloadPage';
import GlobalAccountStubPage from 'apps/auth/components/ga/GlobalAccountStubPage';
import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import AccountActivityListPage from 'apps/auth/pages/ga/AccountActivityListPage';
import PocketPage from 'apps/auth/pages/ga/PocketPage';

const gaAuth = [
    {
        path: '/auth/ga/accounts',
        component: GlobalAccounts,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            initCard: false,
            isGA: true,
        },
    },
    {
        path: ['/auth/ga/stub-page'],
        component: GlobalAccountStubPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/download',
        component: GlobalAccountDownloadPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/activity',
        component: AccountActivityListPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id',
        component: PocketPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/email/confirm/preview',
        component: EmailNotificationGA,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/dual/factor/ga',
        component: EmailAuthentication,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
];

export default gaAuth;
